export const getFieldsFromForm = (formRef) => {
  // filter elements to have just inputs
  const fields = formRef.current.querySelectorAll([
    "input[type='text']",
    "input[type='email']",
    "input[type='number']",
    "select",
    "input[type='radio']:checked",
  ]);

  return Array.from(fields);
};
